// extracted by mini-css-extract-plugin
export default {"paginationUL":"paginator_paginationUL__SvwdZ","active":"paginator_active__14qHi"};